"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { CheckboxGroup, Checkbox as MantineCheckbox, factory, useProps, } from "@mantine/core";
// Global inline input style, must come first
import "@mantine/core/styles/InlineInput.layer.css";
import "@mantine/core/styles/Checkbox.layer.css";
import * as styles from "./Checkbox.module.css";
const Checkbox = factory((props, ref) => {
    const modifiedProps = useProps("Checkbox", {
        classNames: styles,
        size: "md",
    }, props);
    return _jsx(MantineCheckbox, { ...modifiedProps, ref: ref });
});
Checkbox.displayName = "Checkbox";
CheckboxGroup.displayName = "CheckboxGroup";
Checkbox.Group = CheckboxGroup;
export { Checkbox };
//# sourceMappingURL=Checkbox.js.map